import {helpers} from "vuelidate/lib/validators";
const config = {
    app: {
        prefix: "armuserreg",
        host: "https://localhost:8080/armuserreg"
    },
    api: {
        url: "http://127.0.0.1:8000"
    },
    auth: {
        url: "https://auth-api.dev.arm.gov/Auth",
        keycloakURL: "https://keycloak.svcs.arm.gov/auth",
        realm: "Kubernetes",
        clientId: "datatools-oauth2-test",
    },
    archiveServices: {
        url: "https://maintenance-check-api.dev.arm.gov"
    },
    armgov: {
        url: "https://armgov.dev.arm.gov"
    },
    bypassAuth: false,
    testUserId: 25703,
    elastic: {
        url: "https://datatools-elasticsearch.dev.arm.gov",
    },
    identifiers: {
        crossref_id_prefix: "https://doi.org/10.13039/",
        ror_id_prefix: "https://ror.org/",
    },
    notificationService: {
        url: "https://notification-api.dev.arm.gov"
    },
    recaptchaSiteKey: "6LdzDTYUAAAAAL05blc17MfL5erA19qPaRfKngtH",
    validations: {
        zeroOrMoreValidator: helpers.regex("zeroOrMore", /^[^+=<>`'\"\\\/#^{};]*$/),
        nameValidator: helpers.regex("name", /^[^+=<>`'\"\\\/#^{};]+$/),
        zeroOrMoreSlashValidator: helpers.regex("zeroOrMore", /^[^+=<>`'\"\\#^{};]*$/),
        fundersValidator: helpers.regex("funders", /^[^+=<>`\"\\#^{};]+$/),
        oneOrMoreValidator: helpers.regex("oneOrMore", /^[^+=<>`'\"\\\/#^{};]+$/),
        emailValidator: helpers.regex("email", /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/),
        stateValidator: helpers.regex("state", /^[A-Z]{0,2}$/),
        usernameValidator: helpers.regex("username", /^(?=.{3,61}$)[a-z0-9]*[a-z]+[a-z0-9]*$/),
        institutionsValidator: helpers.regex("institutions", /^[^+=<>`\"\\#^{};]+$/),
        projectTitleValidator: helpers.regex("projectTitle", /^(?=.{4,250})[a-zA-Z0-9 ()-:'\",.\/]*[a-z]+[a-zA-Z0-9 ()-:'\",.\/]*$/),
    },
    orcid: {
        authenticateUrl: "https://sandbox.orcid.org/oauth/authorize",
        // authenticateUrl: "https://orcid.org/oauth/authorize",
        // Switch to localhost for local development
        redirectUri: "https://localhost.ornl.gov:8080/armuserreg",
        // redirectUri: "https://localhost:8080/armuserreg/#/new?",
        url: "https://sandbox.orcid.org/",
        // url: "https://orcid.org/",
        publicApiUrl: "https://pub.sandbox.orcid.org/v3.0/",
        // publicApiUrl: "https://pub.orcid.org/v3.0/",
        clientId: "APP-FDCFQU248WMBM3U1",
        // clientId: "APP-6X0JJQLQRFCIONX3",
        responseType: "token",
        scope: "openid",
        nonce: "whatever",
        userInfoCookie: "user_info_arm_user_registration",
        accessTokenCookie: "orcid_access_token_arm_user_registration",
        idTokenCookie: 'orcid_id_token_arm_user_registration',
        mailingListTokenCookie: "mailing_list_token_arm_user_registration",
    },
    allowedCharacters: "! @ $ % & * ( ) - _ [ ] : , . ? |",
    restrictedCharacters: "+ = < > ` ' \" \\ / # ^ { } ;",
    restrictedUsernameCharacters: "@ + = < > ` ' \" \\ / # ^ { } ;",
    restrictedFundersCharacters: "+ = < > ` \" \\ # ^ { } ;",
    restrictedSlashCharacters: "+ = < > ` ' \" \\ # ^ { } ;",
    restrictedInstitutionsCharacters: "+ = < > ` \" \\ # ^ { } ;",
    flagIcon: "src/assets/flag-icon.png",
}

export default config